<template>
  <v-container fluid>
    <SimpleTitleBar>Message Center - Management</SimpleTitleBar>
    <v-card class="pa-4 rounded-2">
      <v-row>
        <!-- Compose / Edit panel: full width when stacked, narrower beside the list on desktop -->
        <v-col id="message-compose-panel" cols="12" md="5" lg="4">
          <router-view />
        </v-col>
        <!-- Sent messages list -->
        <v-col cols="12" md="7" lg="8">
          <MessageCenterSentMessagesList />
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
<script setup lang="ts">
import MessageCenterSentMessagesList from '@/Core.Service.Domain/MessageCenter/Management/Components/MessageCenterSentMessagesList.vue';

import SimpleTitleBar from '@/Core.UI.Domain/Components/SimpleTitleBar.vue';

import { onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const getUsersListForMessageCenter = () => {
  store.dispatch('MessageCenterManagementStore/getUsersListForMessageCenter');
};

onMounted(() => {
  getUsersListForMessageCenter();
});
</script>
